import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-category",
  "use": "icon-category-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-category\"><path fill=\"#333333\" d=\"M796.8 95.3h-542c-81.2 0-147.2 66-147.2 147.2v542c0 81.2 66 147.2 147.2 147.2h542c81.2 0 147.2-66 147.2-147.2v-542c0-81.2-66-147.2-147.2-147.2zM884 784.4c0 48.1-39.1 87.2-87.2 87.2h-542c-48.1 0-87.2-39.1-87.2-87.2v-542c0-48.1 39.1-87.2 87.2-87.2h542c48.1 0 87.2 39.1 87.2 87.2v542z\" /><path fill=\"#333333\" d=\"M756.2 625.3H518.9c-16.6 0-30 13.4-30 30s13.4 30 30 30h237.3c16.6 0 30-13.4 30-30s-13.4-30-30-30zM756.2 459.3H518.9c-16.6 0-30 13.4-30 30s13.4 30 30 30h237.3c16.6 0 30-13.4 30-30s-13.4-30-30-30z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/category.svg
// module id = 3HFE
// module chunks = 5